import { css } from 'lit'
import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const styles = css`
  :host {
    display: contents;
  }

  .levy {
    --cse-text-color: ${csColorText.muted};
  }
`
